// import { BrowserModule } from '@angular/platform-browser';
import { Component, OnInit, Input, Injectable, PLATFORM_ID, Inject, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonModule, isPlatformBrowser, isPlatformServer } from '@angular/common';
// models
import { ModalData } from '../../models/modal.interface';
import { AdminFilters } from '../../models/admin-filters.interface';
import { AddQuestionAnswerRequest } from '../../models/question-answer.interface';
// services
import { ErrorHandler } from '../../services/error-handler.service';
import { CompleteBookingService } from '../../../my-account/services/complete-bookings.service';
import { AddQuestionAnswerService } from '../../services/add-question-answer.service';
import { CollectionService } from '../../../booking/services/collection.service';
import { FlightDetailsService } from '../../services/flight-details.service';
import { PriceService } from '../../../booking/services/price.service';
import { AppStateService } from '../../services/app-state.service';
import { BookingService } from '../../../booking/services/booking.service';
import { DataStorageService } from '../../services/data-storage.service';
import { LoginService } from '../../services/login.service';
import { MilesAndMore } from '../../../booking/services/miles-n-more.service';
// shared functions
// import Shared from '../../../booking/shared/shared';
import { Store } from '@ngrx/store';
import { AppState } from 'app/booking/models/app-state.interface';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
// globals
import { MILES_LOGIN_URL } from '../../../shared/globals';



import { COUNTRY_CODES } from '../../globals';
import { BookerItem } from '../../../booking/models/booking.interface';
import { CopyService } from '../../services/app-copy.service';
import { FormsModule } from '@angular/forms';
import Shared from 'app/booking/shared/shared';
import { ModalTimeSlotExpiredComponent } from '../modal-v2/modal-time-slot-expired/modal-time-slot-expired.component';
import { RemoveServiceModalComponent } from '../modal-v2/remove-service-modal/remove-service-modal.component';

declare var ga: any;
declare var zE: any;
declare var exponea: any;

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, ModalTimeSlotExpiredComponent, RemoveServiceModalComponent],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  providers: [AppStateService, LoginService]
})

@Injectable({
  providedIn: 'root',
})
export class ModalComponent implements OnInit, OnDestroy {

  @ViewChild('form') form;

  @Input()
  appCopy;

  @Input()
  selectedLanguage;

  public modalData: ModalData;
  public modalList: Array<any> = [];
  public destinationSelected: Boolean = false;
  public filtersDisabled: Boolean = true;
  public showDateError: Boolean = false;
  public filtersSelected;
  public cancelReasons: Array<string> = [
    'Can’t get my boarding pass',
    'I’ve changed my mind',
    'I need to amend my booking',
    'My travel plans or flight has changed',
    'Other'
  ];
  public cancelReasonSelected = null;
  public cancelReasonSubmitted: Boolean = false;
  public cancelReasonCustom: string = '';
  public showEmailSent: Boolean = false;
  public showLoader: Boolean = false;
  public countryCodes = {
    featured: [...COUNTRY_CODES.featured],
    all: [...COUNTRY_CODES.featured, ...COUNTRY_CODES.all]
  }
  public emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  public bookerData: BookerItem = {
    firstName: '',
    lastName: '',
    emailAddress: '',
    phoneNumber: '',
    countryCode: '44'
  };
  public appCopyModal:any;
  public fetchedData: any;
  public dataChanged = false;
  public buttonDisabled = true;
  public user:any;

  private _bookingInitSubscription: Subscription;
  private _modalSubscription: Subscription;
  private _emailSentSubscription: Subscription;
  private _bookingDetailsSubscription: Subscription;
  private _validatePhoneNumberSubscription: Subscription;
  private _copyInitSubscription: Subscription;
  private _userSubscription: Subscription;
  private occReasonAdded: boolean = false;
  private phoneNumberSubject = new Subject<string>();
  public validationResult: any;
  public scrollPosition = 0;


  constructor(
    private _completeBookingService: CompleteBookingService,
    private _errorService: ErrorHandler,
    private _addQuestionAnswerService: AddQuestionAnswerService,
    private _collectionService: CollectionService,
    private _flightDetailsService: FlightDetailsService,
    private _pricingService: PriceService,
    private _router: Router,
    private _appStore: Store<AppState>,
    private _appStateService: AppStateService,
    private _bookingService: BookingService,
    private _dataStorageService: DataStorageService,
    private _milesAndMoreService: MilesAndMore,
    private _loginService: LoginService,
    private _copyService: CopyService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    // Subscribe to the phoneNumberSubject observable
    this.phoneNumberSubject.pipe(
      debounceTime(1000),  // Adjust debounce time as needed
      switchMap(async (value) => this._bookingService.validatePhoneNumber(value))
    ).subscribe(result => {
      this.validationResult = result;
      // Handle the result here (e.g., update form control errors or UI)
    });
  }

  ngOnInit() {

    this._copyService.getStaticCopy();

    if (isPlatformBrowser(this.platformId)) {

      this._bookingInitSubscription = this._appStore.select('userReducer')
        .subscribe((res: any) => {
          if (res.userDetails.userLoggedIn && !this.occReasonAdded && (res.userDetails.userRole !== 'CUSTOMER' && res.userDetails.userRole !== 'GUEST' && res.userDetails.userRole && 'PARTNER')) {
            this.occReasonAdded = true;
            this.cancelReasons = [
              'Can’t get boarding pass',
              'Can’t amend as needed',
              'Can’t complete declaration',
              'Timeslot doesn’t suit',
              'Technical issue',
              'Logistics request',
              'Duplicate',
              'Customer changed mind',
              'OCC - Operations Capacity Cancellation',
              'Other'
            ];
          }
        })

      this._modalSubscription = this._errorService.modalItem$
        .subscribe(modalItem => {
          if (modalItem === 'remove') {
            this.closeModal();
            return;
          }
          this.create(modalItem);
        });

        this._emailSentSubscription = this._loginService.resendEmailSent$
        .subscribe(emailSent => {
          if (emailSent.error) {
            this.handleErrors();
            return;
          }

          this.showEmailSent = emailSent;
          if (this.showEmailSent) {
            this.closeModal();
            this.handleErrors();
            const data = {
              text: 'Email sent!',
              type: 'info',
              icon: 'alert',
              sticky: false
            };

            this._errorService.handleCustomInfo(data);
          }

        },
        err => console.log(err));
    }

    this._validatePhoneNumberSubscription = this._bookingService.validPhoneNumberSubject$
      .subscribe(valid => {
        if (!valid) {
          this.form?.controls['contactPhone']?.setErrors({ 'incorrect': true });
          this.buttonDisabled = true;
        } else {
          this.form?.controls['contactPhone']?.setErrors(null);
          this.checkDataChanged()
        }
      });

    this._copyInitSubscription = this._appStore.select('loadedStatusReducer')
    .subscribe((res: any) => {
      if (res.copyLoaded) {
        if (isPlatformBrowser(this.platformId)) {
          this.getCopy();
        }
      }
    });

    this._userSubscription = this._appStore.select('userReducer')
      .subscribe((user: any) => {
        this.user = user;
      });
  }

checkDataChanged() {
  const bookerForm = typeof this.form !== 'undefined';
    if(bookerForm && this.form.valid) {
      this.buttonDisabled = false;
      const bookerEmail = this.form.value.bookerEmail;
      const contactCountryCode = this.form.value.contactCountryCode;
      const contactPhone = this.form.value.contactPhone;
      if(bookerEmail === this.fetchedData.emailAddress && contactCountryCode === this.fetchedData.countryCode && contactPhone === this.fetchedData.phoneNumber) {
        this.dataChanged =  false;
      } else {
        this.dataChanged = true
      }
    }else {
      this.buttonDisabled = true;
    }



    // console.log(this.form.value, this.fetchedData);
}

  handleSavePreferencesSubmit() {
    const bookerForm = typeof this.form !== 'undefined';
    if(bookerForm && this.form.valid) {
      this._loginService.updateUserPreference(this.form.value, this.user.userDetails.userToken, this.user.userDetails.currentUser.userId);
      console.log('button is clicked');
    }
  }

  validatePhoneNumber(countryCode, phoneNumber) {
    this.buttonDisabled = true;
    const re = /^[0-9\b]+$/;
    console.log('validation function load with value',countryCode, phoneNumber);
    if (phoneNumber !== '' && re.test(phoneNumber) && phoneNumber?.toString()?.length >= 10) {
      const value = '+' + countryCode + phoneNumber;
      console.log(value)
      // this._bookingService.validatePhoneNumber(value);
      this.phoneNumberSubject.next(value);
    }
  }

  verifiyAccount(email) {

      if (!this.emailPattern.test(email)) {
        this.form.controls['bookerEmail'].setErrors({ 'pattern': true });
        this.buttonDisabled = true;
      }
      else {
        this.checkDataChanged();
      }
  }


  create(data: any) {

    if (this.modalList.length > 0) {
      this.modalList.splice(0, 1);
    }

    this.modalList.push(data);
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('modal-open');

    this.sendGAData('CancelRequest');
    this.scrollPosition = window.scrollY;
    this.modalList.map((modal) =>{
      if(modal.modalType === 'savePereferences'){
        let parsedPhoneNumber;
        let countrycode;
        if(modal.paymentType === 0) {
          this.bookerData.emailAddress = modal.preferenceData.email;
          parsedPhoneNumber = this._loginService.parsePhoneNumber(modal.preferenceData.shippingAddress.phoneNumber);
          // this._bookingService.validatePhoneNumber(modal.preferenceData.shippingAddress.phoneNumber);
          COUNTRY_CODES.all.find((item) => {
            if(item.countryCodeName === modal.preferenceData.shippingAddress.countryCode) {
              console.log('item.countryName',item.countryName);
              countrycode = item.countryCode
            }
          });
        }
        if(modal.paymentType === 1) {
          this.bookerData.emailAddress = modal.preferenceData.shippingContact.emailAddress;
          parsedPhoneNumber = this._loginService.parsePhoneNumber(modal.preferenceData.shippingContact.phoneNumber);
          // this._bookingService.validatePhoneNumber(modal.preferenceData.shippingContact.phoneNumber);
          COUNTRY_CODES.all.find((item) => {
            if(item.countryName === modal.preferenceData.shippingContact.country) {
              console.log('item.countryName',item.countryName);
              countrycode = item.countryCode
            }
          });
        }


        this.bookerData.countryCode = parsedPhoneNumber.countryCode ? parsedPhoneNumber.countryCode : countrycode
        this.bookerData.phoneNumber = parsedPhoneNumber.phone
        this.fetchedData =  JSON.parse(JSON.stringify(this.bookerData))
        console.log(this.bookerData);

        console.log('call validation function', this.bookerData)
        this.validatePhoneNumber(this.bookerData.countryCode, this.bookerData.phoneNumber)

      }
    })
  }

  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'Modal',
      ['panelHeader']
    );

    this.appCopyModal = {
      panelHeader: panelHeaderCopy[0],
    };

  }

  closeModal(e?, modalType?:string) {
    let email_check: any = true;
    if(!this.form === undefined) {
      if (this.form.value.hasMarketingEnrolment === true) {
        email_check = 'accept'
      } else {
        email_check = 'reject'
      }
    }

    if (isPlatformBrowser(this.platformId)) {
      if (modalType === 'savePereferences') {
        exponea.track('consent', {
          action: email_check,
          email_id: this.bookerData.emailAddress,
          message: 'Untick this box if you do not wish to be kept informed about special offers, new services and airline partners.'
        });
      }
      const body = document.getElementsByTagName('body')[0];
      body.classList.remove('modal-open');
      this.modalList.splice(0, 1);
      this.sendGAData('CancelChangeMind', this.cancelReasons[this.cancelReasonSelected]);
      this.cancelReasonSelected = null;
      this.cancelReasonSubmitted = false;
      window.scrollTo(0, this.scrollPosition);
    }
  }

  removeClasses() {
    if (isPlatformBrowser(this.platformId)) {
      const body = document.getElementsByTagName('body')[0];
      body.classList.remove('modal-open');
      this.closeModal();
    }
  }

  sendGAData(action?: string, label?: string) {
    if (isPlatformBrowser(this.platformId)) {
      const currentUrl = location.pathname;
      const gaAction = action;
      const gaLabel = label ? label : currentUrl;

      ga('send', 'event', 'Funnel', gaAction, gaLabel);
      console.log('send', 'event', 'Funnel', gaAction, gaLabel);
    }
  }

  submitCancelReason() {
    this.cancelReasonSubmitted = true;
    this.sendGAData('CancelContinue', this.cancelReasons[this.cancelReasonSelected]);
  }

  handleErrors() {
    this.showLoader = false;
  }
  resendClickHandler() {
    this.showLoader = true;
    const data = this.modalList[0]
    this._loginService.resendComms(data.email, data.bookingReference);


  }

  // booking delete modal
  deleteBooking(val, bookingRef, journeyRef, userToken) {
    const questionAnswerRequest: AddQuestionAnswerRequest = {
      bookingReference: bookingRef,
      bookingJourneyReference: journeyRef,
      questionAnswer: [{
        question: 'Why are you cancelling?',
        answer: ''
      }],
      client: 2,
      category: 1
    };

    if (this.cancelReasonSelected !== this.cancelReasons.length - 1) {
      questionAnswerRequest.questionAnswer[0].answer = this.cancelReasons[this.cancelReasonSelected];
      this.sendGAData('CancelConfirm', this.cancelReasons[this.cancelReasonSelected]);
    } else {
      questionAnswerRequest.questionAnswer[0].answer = val.cancelReasonCustom;
      this.sendGAData('CancelConfirm', val.cancelReasonCustom);
    }

    this._addQuestionAnswerService.addQuestionAnswer(questionAnswerRequest, userToken);
    this._completeBookingService.deleteBookingItem$.next({bookingRef, reason: questionAnswerRequest.questionAnswer[0].answer});
    this.closeModal();
  }

  // flight direction modal
  goToQuote() {
    if (isPlatformBrowser(this.platformId)) {
      const body = document.getElementsByTagName('body')[0];
      body.classList.remove('modal-open');
      this._router.navigate(['quote']);
    }
  }

  continueBooking() {
    if (isPlatformBrowser(this.platformId)) {
      const body = document.getElementsByTagName('body')[0];
      body.classList.remove('modal-open');
      this.closeModal();
    }
  }

  // admin filters
  clearFilters() {

    this.filtersDisabled = true;

    this.filtersSelected = {
      airport: '',
      type: '',
      startDateDay: null,
      startDateMonth: null,
      startDateYear: null,
      endDateDay: null,
      endDateMonth: null,
      endDateYear: null,
      showPast: false,
      showCancelled: false
    };

    const selectedFilterObj: AdminFilters = {
      startDateTimeUTC: null,
      endDateTimeUTC: null,
      addOnProductType: [],
      airport: [],
      bookingJourneyActivity: 1,
      showCancelledBookings: false,
    };
    this._completeBookingService.setAppliedFilters(this.filterNullValues(selectedFilterObj));
    this.closeModal();

  }

  setAdminFilters() {

    // let selectedFilterObj = null;
    const selectedFilterObj: AdminFilters = {
      startDateTimeUTC: null,
      endDateTimeUTC: null,
      addOnProductType: [],
      airport: [],
      bookingJourneyActivity: 0,
      showCancelledBookings: false
    };

    this.showDateError = false;

    // if no filters selected
    if (typeof this.filtersSelected === 'undefined') {
      return;
    }

    if (
      this.filtersSelected.startDateDay !== null && this.filtersSelected.endDateDay === null ||
      this.filtersSelected.startDateDay === null && this.filtersSelected.endDateDay !== null
    ) {
      this.filtersDisabled = true;
      this.showDateError = true;
      return;
    }

    if (
      this.filtersSelected.startDateDay !== null &&
      this.filtersSelected.startDateMonth !== null &&
      this.filtersSelected.startDateYear !== null
    ) {
      selectedFilterObj.startDateTimeUTC = Shared.multiDateFormat(
        this.filtersSelected.startDateDay, this.filtersSelected.startDateMonth, this.filtersSelected.startDateYear);

      selectedFilterObj.startDateTimeUTC = selectedFilterObj.startDateTimeUTC + 'T12:00:00Z';
    }

    if (
      this.filtersSelected.endDateDay !== null &&
      this.filtersSelected.endDateMonth !== null &&
      this.filtersSelected.endDateYear !== null
    ) {
      selectedFilterObj.endDateTimeUTC = Shared.multiDateFormat(
        this.filtersSelected.endDateDay, this.filtersSelected.endDateMonth, this.filtersSelected.endDateYear);

      selectedFilterObj.endDateTimeUTC = selectedFilterObj.endDateTimeUTC + 'T12:00:00Z';
    }

    if (this.filtersSelected.airport !== '') {
      selectedFilterObj.airport.push(this.filtersSelected.airport);
    }

    if (this.filtersSelected.type !== '') {
      selectedFilterObj.addOnProductType.push(this.filtersSelected.type);
    }

    selectedFilterObj.showCancelledBookings =
      typeof this.filtersSelected.showCancelled !== 'undefined' ? this.filtersSelected.showCancelled : false;

    if (this.filtersSelected.showPast) {
      selectedFilterObj.bookingJourneyActivity = 0;
    } else {
      selectedFilterObj.bookingJourneyActivity = 1;
    }

    this._completeBookingService.setAppliedFilters(this.filterNullValues(selectedFilterObj));
    this.closeModal();
  }

  filterFormValues(filters) {
    this.filtersSelected = filters;
    this.filtersDisabled = false;
  }

  filterNullValues(obj) {
    for (const propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined || obj[propName].length === 0) {
        delete obj[propName];
      }
    }
    return obj;
  }

  // show manual flight search
  showFlightSearch(searchType) {
    this._flightDetailsService.showFlightSearch$.next(searchType);
    this.closeModal();
  }

  deleteCard(ref, id, token) {
    const successMessage = this.appCopy.panelHeader['cardDeletedText' + this.selectedLanguage]
    this._pricingService.removeSavedCard(ref, id, token, successMessage);
    this.closeModal();
  }

  milesLoginRedirect() {
    const milesLoginUrl = MILES_LOGIN_URL;
    const callbackUrl = location.href.split('?')[0];
    this._milesAndMoreService.milesLoginRedirect(milesLoginUrl, callbackUrl);
  }

  handleChatClick() {
    zE.activate();
  }

  resetReasons() {
    this.cancelReasonSelected = null;
    this.cancelReasonSubmitted = false;
  }

  ngOnDestroy(): void {
    if (this._bookingInitSubscription) {
      this._bookingInitSubscription.unsubscribe();
    }
    if (this._userSubscription) {this._userSubscription.unsubscribe();}
    this._copyInitSubscription.unsubscribe();
    if (this._bookingDetailsSubscription) { this._bookingDetailsSubscription.unsubscribe(); }
    if (this._modalSubscription) { this._modalSubscription.unsubscribe(); }
    // this._emailSentSubscription.unsubscribe();
  }
}




